import { render, staticRenderFns } from "./BottomBack.vue?vue&type=template&id=5aafd9c0&scoped=true&"
import script from "./BottomBack.vue?vue&type=script&lang=js&"
export * from "./BottomBack.vue?vue&type=script&lang=js&"
import style0 from "./BottomBack.vue?vue&type=style&index=0&id=5aafd9c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aafd9c0",
  null
  
)

export default component.exports